import InputBase from "./InputBase";

const PasswordInput = (props) => (
  <InputBase {...props} type="password" showPasswordToggle />
);

export default PasswordInput;
